<template>
  <span :class="{notMobile: !isMobile}">
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <span v-bind="attrs"
              style="display: flex;"
              v-on="on">
          <div class="name">
            {{ value.title }}
          </div>
          <div v-if="value.color">
            <fin-circle :fill="value.color" :size="8" class="mx-2"/>
          </div>
        </span>
      </template>
      <span>{{ value.title }}</span>
      <fin-circle v-if="value.color" :fill="value.color" :size="8" class="ml-2"/>
    </v-tooltip>

    <span class="subtitle">{{ value.subTitle }}</span>
      <fin-lexicon-link icon="mdi-minus-circle"
                        to="inaktives-wertpapier"
                        v-if="isInactiveShare"/>
  </span>
</template>

<script>
import FinCircle from "@/components/common/shapes/Circle"
import FinLexiconLink from "@/components/common/lexicon/LexiconLink"

export default {
  name: "InstrumentNameCell",
  components: {
    FinCircle,
    FinLexiconLink
  },
  props: {
    value: {},
    item: {},
    header: {},
    isMobile: {},
  },
  computed: {
    isInactiveShare() {
      if (this.item.instrument && this.item.instrument.active !== undefined && this.item.instrument.covered !== undefined && this.item.instrument.delisted !== undefined) {
        return !this.item.instrument.active || !this.item.instrument.covered || this.item.instrument.delisted
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.name {
  font-size: 16px !important;
  line-height: 1.38;
  font-weight: bold;
  font-family: $body-font-family !important;

  @media only screen and (max-width: 600px) {
    font-size: 13px !important;
  }
}

.notMobile .name {
  white-space: nowrap;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.subtitle {
  font-size: 12px;
  color: #99a0a4;
  line-height: 1.4;
}
</style>
